export enum ClassBSupportStatus {
    UNKNOWN = "UNKNOWN",
    KNOWN_UNSUPPORTED = "KNOWN_UNSUPPORTED",
    SUPPORTED_PENDING_HANDSHAKE = "SUPPORTED_PENDING_HANDSHAKE",
    SUPPORTED_PENDING_CONFIG = "SUPPORTED_PENDING_CONFIG",
    SUPPORTED_AND_AVAILABLE = "SUPPORTED_AND_AVAILABLE",
}
